import { Skeleton } from '@repo/ui/skeleton';
import { cn } from '@repo/utils/cn';
import { memo } from 'react';

type BannerSkeletonProps = {
  className?: string;
};

/**
 * Carousel-like skeleton: shows one central placeholder and partial peeks of two side placeholders
 */
const BannerSkeleton: React.FC<BannerSkeletonProps> = ({ className }) => (
  <div
    dir="ltr"
    className={cn('relative w-full rounded-lg', className)}
  >
    <div className="flex w-full items-center justify-between">
      {/* Left peek */}
      <div className="-ml-[5px] w-[5%] flex-shrink-0 sm:w-[33%]">
        <Skeleton className="h-[180px] w-full rounded-md sm:h-[200px]" />
      </div>

      {/* Center */}
      <div className="mx-auto w-[90%] flex-shrink-0 sm:w-[33%]">
        <Skeleton className="h-[180px] w-full rounded-md sm:h-[200px]" />
      </div>

      {/* Right peek */}
      <div className="-mr-[5px] w-[5%] flex-shrink-0 sm:w-[33%]">
        <Skeleton className="h-[180px] w-full rounded-md sm:h-[200px]" />
      </div>
    </div>
  </div>
);

export default memo(BannerSkeleton);
